type OptionButtonProps = {
  label: string;
  selected: boolean;
  onClick: () => void;
};

const OptionButton = ({ label, selected, onClick }: OptionButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={`rounded-lg border px-4 py-2 text-left transition ${
        selected
          ? 'border-blue-600 bg-blue-50 text-blue-700'
          : 'border-gray-300 hover:bg-gray-100'
      }`}
    >
      {label}
    </button>
  );
};

export default OptionButton;
